import { isValidElement, type ReactNode } from "react"

/** Plain text of a React node tree, for example a Markdown heading with `<strong>` or `<a>` inside. */
export const reactText = (node: ReactNode): string => {
  if (typeof node === "string" || typeof node === "number") {
    return String(node)
  }
  if (Array.isArray(node)) {
    return node.map(reactText).join("")
  }
  if (isValidElement<{ children?: ReactNode }>(node)) {
    return reactText(node.props.children)
  }
  return ""
}
